import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Copy, Trash2, Upload } from "lucide-react";
import { useAdminApi } from "./useAdminApi";
import { assetUrl, errMsg } from "@/lib/api";

export default function AdminMedia() {
  const api = useAdminApi();
  const ref = useRef();
  const [files, setFiles] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api("get", "/admin/files").then(setFiles), [api]);
  useEffect(() => {
    load();
  }, [load]);

  const upload = async (list) => {
    setBusy(true);
    try {
      for (const f of list) {
        const fd = new FormData();
        fd.append("file", f);
        await api("post", "/admin/upload", fd);
      }
      toast.success("Uploaded");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-media">
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={(e) => upload([...e.target.files])} data-testid="admin-media-file-input" />
      <button onClick={() => ref.current.click()} disabled={busy} className="btn-terra mb-6" data-testid="admin-media-upload-button"><Upload className="w-4 h-4" />{busy ? "Uploading..." : "Upload images"}</button>
      <p className="text-sm text-mas-mute mb-5">Copy an image link and paste it into any image field, or upload directly from those fields.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {files?.length === 0 && <p className="text-sm text-mas-mute col-span-full">No uploads yet.</p>}
        {files?.map((f) => (
          <div key={f.id} className="bg-white border border-mas-sand p-2" data-testid={`admin-media-${f.id}`}>
            <img src={assetUrl(f.url)} alt="" className="w-full aspect-square object-cover" />
            <div className="flex justify-between mt-2">
              <button onClick={() => { navigator.clipboard.writeText(f.url); toast.success("Link copied"); }} className="p-1.5" data-testid={`admin-media-copy-${f.id}`}><Copy className="w-4 h-4" /></button>
              <button onClick={async () => { await api("delete", `/admin/files/${f.id}`); load(); }} className="p-1.5 text-mas-terra" data-testid={`admin-media-delete-${f.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
